import palette from '@lib/core/src/theme/palette';
import { Box, Stack, styled } from '@mui/material';

const EventsContainerWidth = '60%';
const EventsContainerHeight = '70%';

interface ImageProps {
  imageUrl?: string;
}

export const Container = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row'
  }
}));

export const Row = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px'
});

export const TitleAndViewAllContainer = styled(Stack)(({ theme }) => ({
  padding: '10px 0 0 20px',
  flexDirection: 'row',
  height: `calc(100% - ${EventsContainerHeight})`,
  width: '100%',
  borderBottom: `1px solid ${palette.grey[1200]}`,
  [theme.breakpoints.up('md')]: {
    padding: '20px 0 0 20px',
    width: `calc(100% - ${EventsContainerWidth})`,
    height: '100%',
    flexDirection: 'column',
    borderRight: `1px solid ${palette.grey[1200]}`,
    borderBottom: 'unset'
  }
}));

export const RightContainer = styled(Stack)(({ theme }) => ({
  padding: '6px',
  height: EventsContainerHeight,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: EventsContainerWidth,
    height: '100%'
  }
}));

export const ScrollContainer = styled(Stack)({
  gap: '8px',
  width: '100%',
  height: '100%',
  overflow: 'auto'
});

export const TitleContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  [theme.breakpoints.up('md')]: {
    height: '50%'
  }
}));

export const ImageContainer = styled(Stack)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  alignItems: 'flex-start',
  flexGrow: 1,
  height: '100%',
  paddingLeft: '8px',
  borderTopRightRadius: '6px',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-end',
    height: '50%',
    paddingLeft: '0px',
    borderTopRightRadius: 'unset'
  }
}));

export const Image = styled(Box, {
  shouldForwardProp: prop => prop !== 'imageUrl'
})<ImageProps>(({ imageUrl, theme }) => ({
  position: 'absolute',
  top: 0,
  right: '-22px',

  width: '120px',
  height: '88px',
  backgroundImage: `url(${imageUrl})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  borderRadius: '6px',
  boxShadow: '0px 8px 18px -6px rgba(24, 39, 75, 0.12), 0px 12px 42px -4px rgba(24, 39, 75, 0.12)',
  [theme.breakpoints.up('md')]: {
    bottom: 0,
    top: 'unset'
  }
}));
